import { corvidToP13n as corvidAddressToP13n, p13nToCorvid as p13nAddressToCorvid, } from './address';
import { coalesce } from './coalesce';
import { corvidToP13n as corvidImageToP13n, p13nToCorvid as p13nImageToCorvid, } from './image';
import { wrap } from './wrap';
const builtinCustomFunctions = {
    image: { corvidToP13n: corvidImageToP13n, p13nToCorvid: p13nImageToCorvid },
    address: {
        p13nToCorvid: p13nAddressToCorvid,
        corvidToP13n: corvidAddressToP13n,
    },
    wrap,
    coalesce,
};
export { builtinCustomFunctions };
//# sourceMappingURL=index.js.map